export const paginationValues = [
  {
    text: '10',
    value: '10',
  },
  {
    text: '25',
    value: '25',
  },
  {
    text: '50',
    value: '50',
  },
];
